<atn-ds-centered-overlay type="wide">
  <div class="atn-space-joint-use-modal">
    <atn-ds-widget title="Update Joint Use">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-joint-use-modal__content">
        <div class="atn-space-joint-use-modal__field">
          <span><b>Calculation Mode</b></span>
          <atn-ds-select-single
            [items]="calculationModeItemsSg()"
            [value]="currentCalculationModeSg()"
            [required]="true"
            (valueChange)="updateJointUseCalculationMode($event)"
          />
        </div>

        @let canEditFunctionalizations = canEditFunctionalizationsSg();
        <div
          class="atn-space-joint-use-modal__field"
          [class.atn-space-joint-use-modal__field--full-height]="
            !canEditFunctionalizations
          "
        >
          <span><b>Allocations</b></span>
          <atn-space-modal-functionalizations
            [functionalizations]="functionalizationsSg()"
            [loading]="isLoadingFunctionalizationsSg()"
            [readonly]="!canEditFunctionalizations"
            (functionalizationChange)="updateManualFunctionalization($event)"
          />
        </div>
      </div>

      <div
        class="atn-space-joint-use-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="!canConfirmSg()"
          [loading]="isSubmittingSg()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
